export const selectAllId = 'selectAllId';
export const WITHOUT_DEPARTMENTS_ID = '1713383261709';
